// extracted by mini-css-extract-plugin
export default {"faqs":"ex-z","faqContent":"fx-z","faq":"gx-z"};